import { Suspense } from 'react';
import CategoryGrid from './DashboardModular/CategoryGrid';
import FeaturesSection from './DashboardModular/FeaturesSection';
import FootnotesSection from './DashboardModular/FootnotesSection';
import HeroSection from './DashboardModular/HeroSection';
import PopularCalculators from './DashboardModular/PopularCalculators';
import TrustSection from './DashboardModular/TrustSection';

export default function Dashboard() {
  return (
    <div className="min-h-screen dark:bg-gray-900">
      <Suspense fallback={<div>Loading...</div>}>
        <HeroSection />
        <CategoryGrid />
        <FeaturesSection />
        <PopularCalculators />
        <TrustSection />
        <FootnotesSection />
      </Suspense>
    </div>
  );
}
